import { render, staticRenderFns } from "./UploadElement.vue?vue&type=template&id=2733999a&scoped=true&"
import script from "./UploadElement.vue?vue&type=script&lang=ts&"
export * from "./UploadElement.vue?vue&type=script&lang=ts&"
import style0 from "./UploadElement.vue?vue&type=style&index=0&id=2733999a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2733999a",
  null
  
)

export default component.exports